import { Button, Box, Flex } from '@sequencehq/core-components'
import {
  GreyGrey20,
  GreyGrey60,
  GreyGrey70,
  GreyGrey80,
  Primary13SemiBold,
  Primary13Regular
} from '@sequencehq/core-components'
import { ReactNode } from 'react'
import { AvailableServices } from 'Integrations/domain'
import Spinner from 'components/Loading/Spinner'
import { useReconnectToIntegration } from 'Integrations/utils/useReconnectToIntegration'
import { ProtectedButton } from 'lib/rbac'

export const NotAuthenticatedItemContent = (props: {
  service: AvailableServices
  serviceName: string
  serviceDescription: string
  'data-testid'?: string
  logo: ReactNode
}) => {
  const { reconnect, reconnecting } = useReconnectToIntegration()

  return (
    <Flex
      width="320px"
      height="100%"
      overflow="auto"
      padding="16px"
      gap="16px"
      data-testid={props['data-testid']}
      alignItems="center"
      justifyContent="center"
      flexDirection="column"
    >
      <Box
        padding="6px"
        borderRadius="6px"
        backgroundColor={GreyGrey20}
        width="fit-content"
      >
        {props.logo}
      </Box>
      <Flex flexDirection="column" gap="4px" alignItems="center">
        <Box {...Primary13SemiBold} color={GreyGrey80}>
          {props.serviceName} has an authentication failure
        </Box>
        <Box {...Primary13Regular} color={GreyGrey70} textAlign="center">
          {props.serviceDescription}
        </Box>
      </Flex>
      <ProtectedButton permission="org.integration:update">
        <Button
          variant="secondary"
          onClick={() => void reconnect(props.service)}
          disabled={reconnecting}
        >
          <Flex gap="8px" alignItems="center">
            {reconnecting && (
              <Spinner height="16px" width="16px" color={GreyGrey60} />
            )}{' '}
            {reconnecting
              ? `Reconnecting to ${props.serviceName}...`
              : `Reconnect to ${props.serviceName}`}
          </Flex>
        </Button>
      </ProtectedButton>
    </Flex>
  )
}
